// EmailJS Configuration Guide
// 
// Step 1: Go to https://www.emailjs.com/ and create a free account
// Step 2: Add an email service (Gmail recommended):
//   - Go to Email Services
//   - Click "Add New Service"
//   - Choose Gmail
//   - Connect your Gmail account
//   - Note down the Service ID
//
// Step 3: Create an email template:
//   - Go to Email Templates
//   - Click "Create New Template"
//   - Use these template variables in your email:
//     Subject: New Contact Form Submission from {{from_name}}
//     
//     Hello,
//     
//     You have received a new contact form submission from your website:
//     
//     Name: {{from_name}}
//     Email: {{from_email}}
//     Phone: {{phone}}
//     
//     Message:
//     {{message}}
//     
//     Best regards,
//     Prangio Designs Website
//
// Step 4: Get your credentials:
//   - Service ID: Found in Email Services section
//   - Template ID: Found in Email Templates section  
//   - Public Key: Go to Account > API Keys > Your Public Key
//
// Step 5: Replace the placeholders in Contact.js with your actual values:
//   - emailjs.init("YOUR_PUBLIC_KEY") 
//   - emailjs.send('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', ...)
//
// Security Note: 
// The public key is safe to expose in frontend code as it's designed for client-side use.
// EmailJS provides built-in rate limiting and domain restrictions for security.

export const EMAILJS_CONFIG = {
  // Replace these with your actual EmailJS credentials
  PUBLIC_KEY: "IIBhkJNKUjTnQDo1B",
  SERVICE_ID: "service_p7qh78p", 
  TEMPLATE_ID: "template_l7wz4ef"
};
